import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Mylogo from "../../assets/images/new/newLogo.jpg";
import dayjs from "dayjs";
import axios from "axios";
import { BaseUrl, RazorPayKey, RazorPayName, RazorPaySecretKey } from "../../BaseUrl/BaseUrl";
import { QRCodeSVG } from "qrcode.react";
import { LoaderContext } from "../../AuthContext/AuthContext";
import LazySection from "../../Pages/Home/LazySection";
import DeliveryTracker from "../DeliveryTracker/DeliveryTracker";
import { GetOrderTrackingDetails } from "../../ApiServices/BookingTrack/BookingTrackApi";
const PujaAtTempleOrderDetails = () => {
  const userID = JSON.parse(localStorage.getItem("userID"));
  const { setLoader, loader, convertTo12Hour } = useContext(LoaderContext);
  const [localData, setLocalData] = useState(null);
  const [orders, setOrders] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();
  const [grandTotal, setGrandTotal] = useState(0)
  const [OrderTrackingDetails, setOrderTrackingDetails] = useState(null)


  const stepMap = [
    { key: "BookingDate", label: "Processed" },
    { key: "ConfirmedDate", label: "Confirmed" },
    { key: "CompletedDate", label: "Completed" },
    { key: "CancelledDate", label: "Cancelled" },
    { key: "RejectedDate", label: "Rejected" }
  ];
  useEffect(() => {
    let AppliedAmount;
    if (Number(location?.state?.CouponCodeAmount !== 0)) {
      AppliedAmount = Number(location?.state?.CouponCodeAmount)
    } else if (Number(location?.state?.WalletAmount !== 0)) {
      AppliedAmount = Number(location?.state?.WalletAmount)
    }
    const totalAmount = Number(Math.round(location.state.PAT_PRICE)) + Number(Math.round(location?.state?.PAT_SAMAGRIPRICE)) + Number(Math.round(location.state.CONVIENCE_FEE)) + Number(Math.round(location?.state?.PAT_TaxAmount))
    setGrandTotal(totalAmount + AppliedAmount)
    console.log('total', totalAmount, AppliedAmount)
  }, [])

  useEffect(() => {
    if (location?.state?.PATB_ID !== null && location?.state?.PATB_ID !== undefined && location?.state?.PATB_ID !== '') {
      GetOrderTrackingDetailsData()
    }
  }, [location])
  const handleProceedRemainingPayment = async () => {
    if (location.state.TOTAL_PRICE - location.state.TRANSACTION_AMT === 0) {
      alert("All the amount already paid");
      return;
    }
    // let totalAmount = parseInt(modelRequestData.totalVal); // Assuming totalVal includes shipping
    // let minPayableAmount = Remaining_Amount; // 20% of the total amount

    let orderIDReturned = location.state.TRB_ID;
    const finalAmount = Number(location.state.TOTAL_PRICE);
    const remainingAmount =
      location?.state?.TOTAL_PRICE - location?.state?.TRANSACTION_AMT;
    const options = {
      key: RazorPayKey,
      key_secret: RazorPaySecretKey,
      amount: remainingAmount * 100,
      currency: "INR",
      name: RazorPayName,
      description: "working",
      image: Mylogo,
      handler: function (response) {
        // console.log(response, "Payment Success");
        const paymentId = response.razorpay_payment_id;

        if (response) {
          axios
            .post(`${BaseUrl}/UpdatePaymentStatus?TYPE=PujaAtTemple`, {
              USER_ID: userID,
              ORDER_ID: orderIDReturned,
              // ORDER_ID: JSON.parse(localStorage.getItem("orderID")),
              TRANSACTION_ID: paymentId,
              PAYMENT_STATUS: "Success",
              TRANSACTION_STATUS: "Success",
              TRANSACTION_AMT: finalAmount,
              REMAING_AMOUNT: 0,
              PAYMENT_DATE: dayjs().format("YYYY-MM-DD"),
            })
            .then((res) => {
              if (res.data.ResponseMessage === "successfully.") {
                // localStorage.setItem("cartItemCount", "0");
                // window.dispatchEvent(new Event("cartUpdated"));
                // setShowCODModal(false);
                // nextStep();
                navigate("/my-location?.state?-darshan-Booking");
              } else {
                alert("Order placement failed, please try again.");
              }
            });
        }

        // const updatedPayload = {
        //   ...razorPayData,
        //   TRANSACTION_ID: paymentId,
        //   TRANSACTION_AMT: minPayableAmount,
        // };

        // axios.post(`${BaseUrl}/BookPooja`, updatedPayload).then((res) => {
        //   debugger;
        //   if (res.data.ResponseMessage === "Order Success.") {
        //     localStorage.setItem("cartItemCount", "0");
        //     window.dispatchEvent(new Event("cartUpdated"));
        //     navigate("/thank-you");
        //   } else {
        //     alert("Order placement failed, please try again.");
        //   }
        // });
      },
      theme: {
        color: "#ff416c",
      },
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
  };


  const handleDownloadInvoice = (ID) => {
    window.open(location?.state?.InvoicePDFURL, "_blank");
    const pdfUrl = location?.state?.InvoicePDFURL; // Replace with your actual URL
    // const link = document.createElement("a");
    // link.href = pdfUrl;
    // link.download = `Invoice_${ID}.pdf`;
    // document.body.appendChild(link);
    // link.click();
    // document.body.removeChild(link);
  };
  function formatToIndianCurrency(amount) {
    if (!amount) return "";

    const [integerPart, decimalPart] = amount.toString().split(".");

    // Format the integer part using Indian numbering system
    const formattedIntegerPart = integerPart.replace(
      // Match groups of 3 digits initially, then groups of 2 digits
      /(\d)(?=(\d\d)+\d$)/g,
      "$1,"
    );

    // Return the formatted value with the decimal part (if present)
    return decimalPart !== undefined
      ? `${formattedIntegerPart}.${decimalPart}`
      : formattedIntegerPart;
  }
  function convertTo12HourFormat(time24) {
    const [hour, minute] = time24.split(":").map(Number);
    const ampm = hour >= 12 ? "PM" : "AM";
    const hour12 = hour % 12 || 12;
    return `${hour12}:${minute.toString().padStart(2, "0")} ${ampm}`;
  }

  const GetOrderTrackingDetailsData = async () => {
    setLoader(true);
    try {
      let response = await GetOrderTrackingDetails(userID, location?.state?.PATB_ID, 'PujaAtTemple'); // Replace with actual import/function call
      if (response?.ResponseCode == "0") {
        setLoader(false);

        const list = response?.DATA || [];
        setOrderTrackingDetails(list[0])

      } else {
        console.error("Bad request");
        setLoader(false);
      }
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  }
  console.log('location?.state?.DrySamagriprice', location?.state?.DrySamagriPrice)
  return (
    <>
      <div className="m-5 p-5 my-4">
        <div className="row">
          {/* Left Section: Multiple Order Items */}
          <div className="col-md-8">

            <div className="card p-3 mb-3 shadow-sm">
              <div className="d-flex align-items-center">
                {/* Product Image on the Left */}
                <img
                  src={location?.state?.PAT_IMAGE}
                  alt="Product"
                  className="rounded"
                  style={{
                    width: "180px",
                    height: "150px",
                    objectFit: "contain",
                  }}
                />

                {/* Product Details in the Center */}
                <div className="flex-grow-1 px-3">
                  <h4 className="fw-bold">{location?.state?.PAT_NAME}</h4>
                  <hr />
                  <p className=" mb-1"> <span className="fw-bold">Temple Address :</span> {location?.state?.PATB_ADDRESS}</p>
                  <p className=" mb-1">
                    <span className="fw-bold">Puja Date :</span>    {location?.state?.PATB_DATE}</p>
                  <p className=" mb-1">
                    <span className="fw-bold">Puja Time :</span>  {convertTo12HourFormat(location?.state?.PATB_TIME)}</p>
                  <p className=" mb-1">
                    <span className="fw-bold">Puja Language :</span>  {location?.state?.PATB_LANG}</p>
                  {location?.state?.PANDIT_NAME === null ? <span className="fw-semibold fs-normal">   Note : You will receive pandit details within 24 hours</span> :
                    <p className=" mb-1">
                      <span className="fw-bold">Pandit Name :</span>   {location?.state?.PANDIT_NAME}</p>
                  }

                </div>

                {/* Price on the Right */}
                {/* <div className="text-end">
                  <h5 className="fw-bold  mb-0">
                    ₹
                    {location?.state?.PAT_PRICE}
                  </h5>

                </div> */}
              </div>

              {/* Order Status */}
              {/* <hr /> */}
            </div>

            {/* <div className="d-flex align-items-center">
              <span className="text-success fw-bold me-2">✔</span>
              <p className="mb-0">Order Confirmed, {location?.state?.REG_DATE}</p>
            </div> */}

            {/* Cancellation Message */}
            {/* <p style={{ fontSize: "17px", fontWeight: "400" }}>
              When you are at temple, please scan below QR code to complete
              your puja.
            </p> */}

            {(OrderTrackingDetails !== null && OrderTrackingDetails !== undefined && OrderTrackingDetails !== '') && (

              <div >
                <LazySection><DeliveryTracker statusData={OrderTrackingDetails} stepMap={stepMap} /></LazySection>
              </div>
            )}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginTop: "30px",
              }}
            >
              {/* <QRCodeSVG value={location?.state?.TRB_ID} /> */}
              {location?.state?.PATB_QRCode ? (
                <QRCodeSVG value={location?.state?.PATB_QRCode?.toString()} />
              ) : (
                <p>Puja at temple QR ID is not available.</p>
              )}

              {/* <QRCodeCanvas
                  value={`${myomnamoQRLink}`}
                  size={150}
                  bgColor="#ffffff"
                  fgColor="#000000"
                  level="H"
                /> */}
            </div>
          </div>

          {/* Right Section: Single Product's Shipping & Price Details */}
          <div className="col-md-4">
            {/* Shipping Details */}
            {/* <div className="card p-3 mb-3 shadow-sm">
              <h6 className="fw-bold">Other details</h6>

              <p className="text-muted small">
                {location?.state?.PAT_ADDRESS}
              </p>

              <p className="fw-bold mb-0">Phone number: {location?.state?.MOBILE_NO}</p>
            </div> */}

            {/* Price Details (Using First Product) */}

            <div className="card p-3 shadow-sm">
              <h4 className="fw-bold">Price Details</h4>
              <hr />
              <div className="d-flex justify-content-between">
                <p className=" fw-bold">Puja Price (₹) :</p>
                <p >{location?.state?.PAT_PRICE}</p>
              </div>
              {location?.state?.CouponCodeAmount !== 0 ? (
                <div className="d-flex justify-content-between">
                  <p className=" fw-bold">
                    Coupon Amount (₹) :
                  </p>
                  <p >
                    {location?.state?.CouponCodeAmount}
                  </p>
                </div>
              ) : location?.state?.WalletAmount !== 0 ?
                <div className="d-flex justify-content-between">
                  <p className=" fw-bold">
                    Wallet Amount (₹) :
                  </p>
                  <p  >
                    {location?.state?.WalletAmount}
                  </p>
                </div> : ''}
              {location?.state?.NeedDrySamagri === "yes" && location?.state?.NeedWetSamagri === "yes" && location?.state?.NeedWetSamagri !== null && location?.state?.NeedDrySamagri !== null ? (
                <div className="d-flex justify-content-between">
                  <p className="fw-bold">Samagri Price (₹) :</p>
                  <p>
                    {formatToIndianCurrency(
                      Math.round(
                        Number(location?.state?.WetSamagriPrice || 0) +
                        Number(location?.state?.WetSamagriPriceTaxAmount || 0) +
                        Number(location?.state?.DrySamagriPrice || 0) +
                        Number(location?.state?.DrySamagriPriceTaxAmount || 0)
                      )
                    )}
                  </p>
                </div>
              ) : location?.state?.NeedDrySamagri === "yes" && location?.state?.NeedWetSamagri === "no" && location?.state?.NeedWetSamagri !== null && location?.state?.NeedDrySamagri !== null ? (
                <div className="d-flex justify-content-between">
                  <p className="fw-bold">Dry Samagri Price (₹) :</p>
                  <p>
                    {formatToIndianCurrency(
                      Math.round(
                        Number(location?.state?.DrySamagriPrice || 0) +
                        Number(location?.state?.DrySamagriPriceTaxAmount || 0)
                      )
                    )}
                  </p>
                </div>
              ) : location?.state?.NeedDrySamagri === "no" && location?.state?.NeedWetSamagri === "yes" && location?.state?.NeedWetSamagri !== null && location?.state?.NeedDrySamagri !== null ? (
                <div className="d-flex justify-content-between">
                  <p className="fw-bold">Wet Samagri Price (₹) :</p>
                  <p>
                    {formatToIndianCurrency(
                      Math.round(
                        Number(location?.state?.WetSamagriPrice || 0) +
                        Number(location?.state?.WetSamagriPriceTaxAmount || 0)
                      )
                    )}
                  </p>
                </div>
              ) : null}

              <div className="d-flex justify-content-between">
                <p className="fw-bold"> Convenience Fee (₹) :</p>
                <p className=" fw-bold">
                  <span>  {Math.round(Number(location.state.CONVIENCE_FEE) + Number(location?.state?.ConvinienceFeeTaxAmount))}</span>
                </p>
              </div>
              {/* <div className="d-flex justify-content-between">
                <p className="fw-bold"> Convenience Tax ({location?.state?.ConvinienceFeeTaxPercent}%) </p>
                <p className=" fw-bold">
                  <span>  {Math.round(location?.state?.ConvinienceFeeTaxAmount)}</span>
                </p>
              </div> */}
              <hr></hr>


              <div className="d-flex justify-content-between">
                <p className="fw-bold">Grand Total (₹) :</p>
                <p className=" fw-bold">
                  <span >
                    {location?.state?.TOTAL_PRICE}
                  </span>
                </p>
              </div>
            </div>

            {location?.state?.RemainingAmount == 0 && (
              <button
                className="careox-btn mt-2"
                onClick={() => handleDownloadInvoice(location?.state?.TRB_ID)}
              >
                Download Invoice
              </button>
            )}


            {/* <button
              className="careox-btn mt-2"
              onClick={() => {

                if (location?.state?.PAYMENT_TYPE == 'COD') {
                  navigate("/receipt-details", {
                    state: { moduleName: "PoojaAtTemple", orderID: location?.state?.PATB_ID },
                  })
                } else {

                  navigate("/view-receipt", {
                    state: { moduleName: "PoojaAtTemple", orderID: location?.state?.PATB_ID },
                  })
                }
              }
              }
            >
              View Receipt
            </button> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default PujaAtTempleOrderDetails;
